import React from 'react';
import PropTypes from 'prop-types';
import AgentCard from '@/components/AgentCard';

function AgentTile({ agent, onPress, onUseAgent, isLoading }) {
  return (
    <AgentCard
      agent={agent}
      onPress={onPress}
      onUseAgent={onUseAgent || onPress}
      isLoading={isLoading}
    />
  );
}

AgentTile.propTypes = {
  agent: PropTypes.object,
  onPress: PropTypes.func,
  onUseAgent: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default React.memo(AgentTile);
